export default function formattedNumber(n, dp = 0) {
  if (Number.isFinite(Number(n))) {
    if (!dp) {
      return Number(Math.round(n)).toLocaleString("en-gb");
    } else {
      return Number(n).toFixed(dp).toLocaleString("en-gb");
    }
  } else return "-";
}
